module.exports = __webpack_public_path__ + "img/m_icn_lang_white.2f139c0a.svg";